export default (state = null, action) => {
  return {name: 'THCM Service'};
};
